import styled, {css} from 'styled-components';

import {breakpoint, colors, font} from '../../../theme';

export const baseStyle = css`
    margin: 0;
    font-weight: 400;
    font-family: ${font.family.primary};
    letter-spacing: -0.5px;
    color: ${colors.textPrimary};
`;

export const H1 = styled.h1`
    ${baseStyle};
    font-size: 36px;

    @media (min-width: ${breakpoint.tablet}) {
        font-size: 52px;
    }
`;

export const H2 = styled.h2`
    ${baseStyle};
    font-size: 28px;

    @media (min-width: ${breakpoint.tablet}) {
        font-size: 36px;
    }
`;

export const H3 = styled.h3`
    ${baseStyle};
    font-size: 24px;

    @media (min-width: ${breakpoint.tablet}) {
        font-size: 28px;
    }
`;

export const H4 = styled.h4`
    ${baseStyle};
    font-size: 22px;

    @media (min-width: ${breakpoint.tablet}) {
        font-size: 24px;
    }
`;
